import { neosAccountRequest } from "../config";
import { ListInvoicesResponse, listInvoicesResponseDecoder } from "./interfaces";

export async function getInvoices(): Promise<ListInvoicesResponse> {
  const { data } = await neosAccountRequest.get<ListInvoicesResponse>(`invoices/`);
  return listInvoicesResponseDecoder.verify(data);
}
